export const environment = {
  production: true,
  builderApiKey: "",
  apiUrl: 'https://blueprint-api-dev.syzl.io',
  stripePublishableKey: "pk_test_51K0LHUG7W2eb3jPinmckYfy6QWUYK9EJsdlveVhGoghhIbOWckNTGYsKGt7VZb9xCZntGRAzSyndwsJGBURomkkw00Wjnwkmi5"
};

